import { render, staticRenderFns } from "./xptblock.vue?vue&type=template&id=658e7ef4&scoped=true&"
import script from "./xptblock.vue?vue&type=script&lang=js&"
export * from "./xptblock.vue?vue&type=script&lang=js&"
import style0 from "./xptblock.vue?vue&type=style&index=0&id=658e7ef4&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "658e7ef4",
  null
  
)

export default component.exports